import { css } from "styled-components";
import { theme } from "./theme";

export const pagePaddingX = css`
  padding-left: ${theme.layout.paddingX};
  padding-right: ${theme.layout.paddingX};

  @media only screen and (max-width: 1024px) {
    padding-left: ${theme.layout.paddingXTablet};
    padding-right: ${theme.layout.paddingXTablet};
  }

  @media only screen and (max-width: 768px) {
    padding-left: ${theme.layout.paddingXMobile};
    padding-right: ${theme.layout.paddingXMobile};
  }
`;

export const sectionInner = css`
  max-width: ${theme.layout.maxWidth};
  margin: 0 auto;
  width: 100%;
  ${pagePaddingX}
`;
